import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { interval, switchMap, tap, firstValueFrom } from "rxjs";

@Injectable({ providedIn: 'root' })
export class BuildVersionService {
  private version: string | null = null;
  private initialized = false;
  private readonly intervalMs = 2500;

  constructor(private http: HttpClient) {}

  /**
   * İlk açılışta versiyon bilgisini yükler ve kaydeder.
   */
  async loadVersion(): Promise<string> {
    try {
      const res = await firstValueFrom(
        this.http.get<{ version: string }>('/assets/version.json')
      );
      this.version = res.version;
      (window as any).APP_VERSION = res.version;
      return res.version;
    } catch (err) {
      console.error('Version load failed:', err);
      throw err;
    }
  }

  init(): void {
    if (this.initialized) return;

    interval(this.intervalMs)
      .pipe(
        switchMap(() =>
          this.http.get<{ version: string }>(`/assets/version.json?t=${Date.now()}`)
        ),
        tap((res) => {
          const current = (window as any).APP_VERSION;
          if (res.version !== current && typeof current !== 'undefined') {
            console.warn('[New Version] New build detected. Reloading page...');
            window.location.reload();
          }
        })
      )
      .subscribe();

    this.initialized = true;
  }

  getCurrentVersion(): string | null {
    return this.version;
  }
}
